<template>
  <div v-if="is_locked" class="w-full h-full flex flex-col items-center justify-center bg-[#2DA7D7]/40">
    <div
      class="absolute right-2 top-2 w-8 h-8 ml-2 bg-white border rounded-full cursor-pointer has-tooltip dark:border-dark-divider-border dark:bg-dark-screen-background"
      @click="is_locked = false">
      <X color="#FF0000" class="w-6 h-6 ml-[3px] mt-[3px] transition ease-in-out duration-side-menu-transition-duration" />
    </div>
    <div class="flex w-[1000px] h-[200px] rounded-xl mb-3 bg-white">
      <div class="w-1/4">
        <img class="flex-shrink-0 h-full rounded-l-xl shadow-md-custom" src="@/assets/5-images.png">
      </div>
      <div class="w-2/4 flex flex-col justify-center">
        <span class="text-[26px] font-medium">{{ $t("Add more companies") }}</span>
        <span class="text-[26px] font-medium">to unlock <span class="font-bold">{{ $t("Customer Leads") }}</span></span>
        <div class="flex items-center gap-x-2 w-full mt-4">
          <span class="w-2 h-2 rounded-full bg-gradient-to-r from-[#2DA7D7] to-[#841FF4]/50" />
          <span class="font-medium">{{ $t("Find Leads") }}</span>
          <span class="w-2 h-2 rounded-full bg-gradient-to-r from-[#2DA7D7] to-[#841FF4]/50" />
          <span class="font-medium">{{ $t("Expansion Lists") }}</span>
          <span class="w-2 h-2 rounded-full bg-gradient-to-r from-[#2DA7D7] to-[#841FF4]/50" />
          <span class="font-medium">{{ $t("Suggested Lists") }}</span>
          <span class="w-2 h-2 rounded-full bg-gradient-to-r from-[#2DA7D7] to-[#841FF4]/50" />
          <span class="font-medium">{{ $t("Growth Matrix") }}</span>
        </div>
      </div>
      <div class="w-1/4">
        <div
          class="flex items-center border-transparent bg-gradient-to-r from-[#2DA7D7] to-[#841FF4] px-3 mt-9 font-bold text-white rounded-full h-[50px] text-[14px] w-fit hover:cursor-pointer"
          @click="$emitter.emit(ALL_EMITTERS.ADD_NEW_RECORD_MODAL)">
          <FilePlus class="text-white w-5 h-5 ml-1 mr-2" />
          <span>{{ $t("Add Multiple Records") }}</span>
        </div>
      </div>
    </div>
    <FindLeadsLocked class="rounded-xl !m-0 !p-0" />
  </div>
  <div v-else class="w-full h-full overflow-visible">
    <div v-if="label && $route.params.page != 'find_leads'" class="pt-2 ml-2 cursor-default">
      <span class="text-[20px] not-italic font-medium font-sans truncate overflow-ellipsis">{{ label }}</span>
    </div>
    <div class="flex w-full min-h-[300px] mb-2">
      <div class="w-2/3 mr-2 bg-white rounded-lg">
        <div class="relative -mt-2">
          <div class="bg-gradient-to-b from-[#B0D0FF]/70 h-36 w-[100%] absolute left-0 -top-2 rounded-lg pointer-events-none" />
          <div class="absolute right-2 top-0 cursor-pointer z-30" @click="emitFilter()">
            <div
              class="flex items-center border-transparent bg-gradient-to-r from-[#2DA7D7] to-[#841FF4] px-6 font-bold text-white rounded-full w-fit-content h-[50px] content-center text-[14px]">
              <Search class="text-white w-7 h-7 ml-1 mr-3" />
              <span>{{ $t("Search for Leads") }}</span>
            </div>
          </div>
          <div class="text-black flex relative z-10 mt-4 ml-2 items-center space-x-4">
            <ListFilter color="black" class="w-8 h-8 text-black" />
            <span class="text-2xl">{{ $t("Search For") }}</span>
            <SelectInput
              v-model="object_type"
              :items="$store.state.object_types"
              :value="$store.state.object_types.filter((o) => o.type == object_type)[0].type"
              name="prospecting_filter"
              label-attr="label"
              value-attr="type"
              :allow-null="false"
              :is-box-background="true"
              :inline-label="true"
              :show-label="false"
              classes="w-[150px]"
              input-classes="!bg-transparent !font-bold !text-[14px] !text-black !border-1 !border-black"
              label=""
              :placeholder="$t('Select object to filter with')"
              @update:currentItem="handleFilter" />
            <span class="text-2xl">Leads</span>
          </div>
          <div class="text-common-grey relative mt-1 ml-2">
            {{ $t("Search records from your portfolio.") }}
          </div>

          <AdvancedMetricsFilterForm
            class="!m-0 px-4 pt-2"
            :read-only="false"
            :current-filter="current_filter"
            :initial-filter="current_filter"
            :disabled="false"
            :is-box-background="false"
            :object-type="object_type"
            @filter="
              ($event) => {
                filter = $utils.clone($event)
              }
            " />
        </div>
      </div>
      <div class="w-1/3 bg-white rounded-lg">
        <div class="hidden lg:block">
          <nav class="-mb-px flex border-b-[1px] rounded-tr-md dark:border-dark-divider-border border-[#B3CAD6] cursor-pointer">
            <div
              v-for="tab in tabs"
              :key="tab.name"
              class="relative cursor-pointer"
              :class="[
                tab.name == current_tab?.name ? 'text-light-brand-blue dark:text-dark-brand-blue' : 'text-common-grey',
                'flex justify-center items-center whitespace-nowrap py-4 px-3.5 text-sm'
              ]"
              @click="changeTab(tab)">
              <component :is="tab.icon" :active="current_tab?.name == tab.name" class="w-5 h-5" aria-hidden="true" />
              <span class="ml-3 truncate cursor-pointer">
                {{ tab.name }}
              </span>
              <div
                :class="[
                  tab.name == current_tab?.name ? ' cursor-pointer ' : '  cursor-pointer scale-0',
                  'absolute pointer-events-none transition transform ease-in-out duration-side-menu-transition-duration w-full left-0 h-[2px] bg-light-brand-blue dark:bg-dark-brand-blue bottom-[-1px]'
                ]" />
            </div>
          </nav>
          <div v-if="current_tab?.name == $t('Recent Searches')">
            <div
              v-if="saved_list.length"
              class="w-full pl-[10px] pr-[28px] py-[16px] mb-2 rounded-xl shadow-sm flex flex-col dark:bg-dark-box-background bg-light-box-background transition ease-in-out duration-side-menu-transition-duration">
              <div v-for="search_item in search_list.filter((o) => o.type == object_type && !o.saved)" :key="search_item.id">
                <SearchItem :item="search_item" :search-item-click="searchItemClick" :save-or-delete-item-click="saveOrDeleteItemClick" />
              </div>
            </div>
          </div>
          <div v-if="current_tab?.name == $t('Saved Searches')">
            <div
              v-if="saved_list.length"
              class="w-full pl-[10px] pr-[28px] py-[16px] mb-2 rounded-xl shadow-sm flex flex-col dark:bg-dark-box-background bg-light-box-background transition ease-in-out duration-side-menu-transition-duration">
              <div
                v-for="search_item in search_list.concat(saved_list).filter((o) => o.type == object_type && o.saved)"
                :key="search_item.id">
                <SearchItem :item="search_item" :search-item-click="searchItemClick" :save-or-delete-item-click="saveOrDeleteItemClick" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="pt-2 bg-white rounded-lg">
      <div class="flex items-center mb-2">
        <div v-click-outside="handleSearchBlur" class="w-full ml-3" :class="{ 'pointer-events-none opacity-0': !current_filter }">
          <AutoCompleteInput
            :placeholder="$t('Search in Leads')"
            :endpoint-async-url="getMetricSuggestionUrl()"
            :is-async="true"
            separator=","
            type="text"
            icon="Search"
            :is-box-background="true"
            tabindex="0"
            classes="p-0 w-full ml-0"
            :input-classes="`form-input `"
            @changed="handleSearchTermChange"
            @chosen="
              ($event) => {
                handleSelectTerm($event)
              }
            "
            @reset="
              () => {
                search_term = ''
                search_term_queue = ''
              }
            " />
        </div>
        <div class="relative flex flex-row justify-end mr-3">
          <RecordActionsDropDown
            :box-background="true"
            :icon-button="true"
            :current-filter="current_filter"
            class="ml-auto"
            :object-type="object_type"
            :page-reference="PAGE_REFERENCES.PROSPECTING_PROSPECT"
            :selected-records="selected_records"
            :selected-full-records="selected_full_records" />

          <div class="flex-shrink-0 ml-1">
            <button
              class="inline-flex px-2 py-2 font-medium border border-gray-200 rounded-md has-tooltip hover:bg-gray-100 sm:text-sm focus:outline-none"
              @click.passive="
                $emitter.emit(ALL_EMITTERS.UPDATE_METRICS, {
                  page_reference: PAGE_REFERENCES.PROSPECTING_PROSPECT,
                  object_type: object_type,
                  view_type: VIEW_TYPES.TABLE
                })
              ">
              <Grid2x2Plus class="w-5 h-5 text-gray-500" aria-hidden="true" />
            </button>
          </div>
        </div>
      </div>
      <div class="h-full outline-none">
        <keep-alive>
          <div
            class="relative mb-5 min-h-[400px] h-full min-w-[100%] rounded-lg transition ease-in-out duration-side-menu-transition-duration flex">
            <div class="flex flex-col w-full h-full gap-2 mx-1 overflow-auto">
              <div
                key="table"
                class="slide-panel-item bg-light-box-background dark:bg-dark-box-background !h-[70vh] max-w-full min-w-full w-full mb-2 !overflow-visible min-h-[200px]">
                <AdvancedCompaniesMetricsTable
                  v-model:selected-records="selected_records"
                  v-model:selected-full-records="selected_full_records"
                  v-model:records="records"
                  v-model:filter="current_filter"
                  v-model:initial-records="initial_records"
                  v-model:sorting="sorting"
                  class="!overflow-visible"
                  :disable-fetch="true"
                  :object-type="object_type"
                  :page-reference="PAGE_REFERENCES.PROSPECTING_PROSPECT"
                  :is-searching="is_searching"
                  :adjustable="true"
                  @update:page-values="handleUpdatePageValues" />
              </div>
            </div>
          </div>
        </keep-alive>
      </div>
    </div>
  </div>
</template>

<script>
import AddNewRecordModal from "@/components/forms/AddNewRecordModal.vue"
import AdvancedMetricsFilter from "@/components/shared/AdvancedMetricsFilter.vue"
import AdvancedMetricsFilterForm from "@/components/forms/AdvancedMetricsFilterForm.vue"
import RecordActionsDropDown from "@/components/shared/RecordActionsDropDown.vue"
import AdvancedCompaniesMetricsTable from "@/components/shared/AdvancedCompaniesMetricsTable.vue"
import SearchList from "@/components/shared/SearchList.vue"
import dataService from "@/services/data.service"
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/vue"
import SearchItem from "@/components/shared/SearchItem.vue"
import SelectInput from "@/components/shared/SelectInput.vue"
import { PAGE_REFERENCES, VIEW_TYPES } from "@/store/constants/references"
import { utils } from "@/store/helpers"
import { ListFilter, Search, FilePlus, X, Inbox, Grid2x2Plus } from "lucide-vue-next"
import AutoCompleteInput from "@/components/shared/AutoCompleteInput.vue"
import FindLeadsLocked from "@/components/shared/FindLeadsLocked.vue"
import { ALL_EMITTERS } from "@/store/constants/all_emitters"

export default {
  components: {
    X,
    FilePlus,
    FindLeadsLocked,
    AddNewRecordModal,
    SearchItem,
    ListFilter,
    Search,
    Inbox,
    Menu,
    AutoCompleteInput,
    MenuButton,
    MenuItem,
    MenuItems,
    SearchList,
    RecordActionsDropDown,
    AdvancedCompaniesMetricsTable,
    AdvancedMetricsFilterForm,
    AdvancedMetricsFilter,
    SelectInput,
    Grid2x2Plus
  },
  props: {
    label: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      is_locked: false,
      tabs: [
        { name: this.$t("Recent Searches"), icon: Search },
        { name: this.$t("Saved Searches"), icon: Inbox }
      ],
      current_tab: { name: this.$t("Recent Searches"), icon: Search },
      ALL_EMITTERS,
      PAGE_REFERENCES,
      VIEW_TYPES,
      sorting: "",
      is_searching: false,
      selected_item: null,
      object_type: "company",
      current_filter: "",
      filter: "",
      selected_records: [],
      selected_full_records: [],
      search_list: [],
      records: [],
      initial_records: [],
      saved_list: [],
      search_term: "",
      search_term_queue: "",
      avoid_blur_trigger: false
    }
  },
  computed: {
    full_filter() {
      let full_filter_calc = ""
      if (this.current_filter) {
        full_filter_calc = this.current_filter
      }

      if (this.search_term) {
        let name_filter
        if (this.object_type == "contact") {
          name_filter = [
            utils.getOptionMetricReference("contact", "first_name"),
            "in",
            `'${this.search_term.split(" ")[0]}'`,
            this.search_term.split(" ").length > 1 && this.search_term.split(" ")[1] ? "and" : "or",
            utils.getOptionMetricReference("contact", "last_name"),
            "in",
            `'${
              this.search_term.split(" ").length > 1 && this.search_term.split(" ")[1] ? this.search_term.split(" ")[1] : this.search_term
            }'`,
            "or",
            utils.getOptionMetricReference("contact", "email"),
            "in",
            `'${this.search_term.split(" ")[0]}'`
          ].join(" ")
        } else {
          name_filter = `${utils.getOptionMetricReference(this.object_type, "name")} in '${this.search_term}'`
        }
        full_filter_calc = full_filter_calc ? `${full_filter_calc} and ${name_filter}` : name_filter
      }
      return full_filter_calc
    }
  },
  watch: {
    selected_records() {
      if (this.selected_records.length) {
        this.$emit("update:selectedRecords", this.selected_records) // for PageView RollupMetricsGrid
      } else {
        let initial_records = this.initial_records?.results?.map((r) => r.id)
        this.$emit("update:selectedRecords", initial_records) // for PageView RollupMetricsGrid
      }
    },
    full_filter() {
      if (utils.isNotEmpty(this.full_filter)) {
        this.fetchRecords()
      }
    }
  },
  created() {
    this.register_listeners()
    this.search_list = this.$store.state.data.recent_searches ? this.$store.state.data.recent_searches : []
    dataService.getSavedList().then((res) => {
      this.saved_list = res.data.results.map((r) => {
        return { ...r, saved: true }
      })
    })
  },
  activated() {
    this.register_listeners()
  },
  deactivated() {
    this.unregister_listeners()
  },
  unmounted() {
    this.unregister_listeners()
  },
  methods: {
    changeTab(tab) {
      this.current_tab = tab
    },
    emitFilter() {
      this.current_filter = this.filter
      this.addToList()
    },
    handleSearchBlur() {
      if (!this.avoid_blur_trigger) {
        this.search_term = this.search_term_queue
      }
    },
    getMetricSuggestionUrl() {
      let object_type_name_metric_id = utils.getMetricByReferenceName(utils.getOptionMetricReference(this.object_type, "name")).id
      return `/api/organizations/${this.$store.state.organization.id}/metrics/${object_type_name_metric_id}/suggestions/`
    },
    handleSearchTermChange(e) {
      this.search_term_queue = e
    },
    handleSelectTerm(e) {
      this.avoid_blur_trigger = true
      setTimeout(() => {
        this.avoid_blur_trigger = false
      }, 1000)
      this.search_term_queue = e
      this.search_term = e
    },
    fetchRecords(page_size = 20, page = 1) {
      let params = { page_size: page_size, page: page, ordering: this.sorting }
      this.$store.dispatch("ui/showLoading")
      delete params["type"]
      dataService
        .filterRecords({ filter: this.full_filter, object_types: [this.object_type] }, params)
        .then((result) => {
          this.records = result.data.results
          this.initial_records = result.data
          let records = this.records.map((r) => r.id)
          this.$emit("update:selectedRecords", records)
          // }
          this.$store.dispatch("ui/hideLoading")
        })
        .catch(() => {
          this.$store.dispatch("ui/hideLoading")
        })
    },
    handleUpdatePageValues({ page_size, page_number }) {
      this.fetchRecords(page_size, page_number)
    },

    register_listeners() {
      this.$emitter.on(ALL_EMITTERS.DELTEE_PROSPECTING_SEARCH, (item) => {
        const index = this.saved_list.findIndex((x) => x.id == item.id)
        this.saved_list.splice(index, 1)
        dataService.deleteFromSavedList(item.id)
      })
    },
    unregister_listeners() {
      this.$emitter.off(ALL_EMITTERS.DELTEE_PROSPECTING_SEARCH)
    },
    handleFilter(otype) {
      this.object_type = otype
      this.current_filter = ""
      this.selected_records = []
      this.selected_full_records = []
    },
    searchItemClick(item) {
      this.current_filter = item.filter
      this.selected_item = item
    },
    saveOrDeleteItemClick(item) {
      if (item.saved) {
        this.$emitter.emit(ALL_EMITTERS.REMOVE_SEARCH_ITEM, { search_item: item })
      } else {
        const index = this.search_list.findIndex((x) => x.id == item.id)
        this.search_list.splice(index, 1)
        this.$store.dispatch("data/updateSearchList", this.search_list)
        dataService
          .addToSavedList({
            ...item,
            group_type: "saved_filter",
            organization: this.$store.state.organization.id,
            name: "-",
            object_type: utils.getObjectTypeByType(this.object_type).id || "company"
          })
          .then((res) => {
            this.saved_list.unshift({ ...res.data, saved: true, type: this.object_type })
            this.$toast.open({
              message: "Search saved successfully",
              position: "top",
              type: "success",
              duration: 3000
            })
          })
      }
    },
    addToList() {
      if (this.current_filter) {
        const new_item = {
          id: this.search_list.length + 1,
          date: new Date(),
          type: this.object_type,
          filter: this.current_filter,
          saved: false,
          name: ""
        }
        this.search_list.unshift(new_item)

        this.$store.dispatch("data/updateSearchList", this.search_list)
        this.selected_item = new_item
      }
    }
  }
}
</script>
